export default {
  isAuthenticated: false,
  email: '',
  code: '',
  me: {}
};